export default __webpack_public_path__ + "img/Montserrat-SemiBold_1972135.woff";